import { type FC, useState } from 'react';

import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useShareToken } from '@/features/admin-interview';
import { type CandidateBasicDto } from '@/services/api';

import { IconSms } from '../../components/Icons';
import { SmsCandidatesConfirmationModal } from './SmsCandidatesConfirmationModal';

type SmsCandidatesCtaProps = {
  selectedCandidates: Array<CandidateBasicDto>;
  totalCandidates: number;
  interviewId?: string;
  onClearSelection: () => void;
  isDropDownButton?: boolean;
};

export const SmsCandidatesCTA: FC<SmsCandidatesCtaProps> = ({
  selectedCandidates,
  totalCandidates,
  interviewId,
  onClearSelection,
  isDropDownButton,
}: SmsCandidatesCtaProps) => {
  const shareToken = useShareToken();
  const { t } = useTranslation(['candidate']);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const count = selectedCandidates.length;

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        leftIcon={<IconSms fontSize={isDropDownButton ? 'xl' : 16} />}
        isDisabled={!!shareToken || totalCandidates === 0}
        size="md"
        variant={isDropDownButton ? 'unstyled' : 'solid'}
        px={3}
        w={isDropDownButton ? 'full' : 'auto'}
        textAlign="left"
        _hover={{ bg: 'gray.50' }}
        borderRadius={isDropDownButton ? 0 : 'xl'}
      >
        {t('candidate:inviteNewCandidate.smsToCandidates', {
          count,
        })}
      </Button>

      <SmsCandidatesConfirmationModal
        isOpen={isModalOpen}
        onClose={() => {
          onClearSelection();
          setIsModalOpen(false);
        }}
        interviewId={interviewId ?? ''}
        selectedCandidates={selectedCandidates}
      />
    </>
  );
};
